import { gql } from '@apollo/client'

export default gql`
  mutation createVisitInterest($input: InterestInput!) {
    interestCreate(input: $input) {
      id
      uuid
      credentials {
        jwt
        user {
          name
          id
          email
          phone
          role
        }
      }
    }
  }
`
